@if (pagesCount > 1) {
  <div id="data-table-selection-footer" class="bootgrid-footer container-fluid">
    <div class="row">
      <div class="col-md-12">
        <ul class="pagination">
          @for (page of pages; track page) {
            <li  class="paginate_button page-item" [ngClass]="{active: page == currentPage}">
              @if (page !== '...') {
                <a class="page-link button" href="javascript:void(0)"
                (click)="setCurrentPage(page)">{{page + 1}}</a>
              }
              @if (page === '...') {
                <a  href="javascript:void(0)" class="page-link button disabled">
                  <i class="fa fa-ellipsis-h"></i></a>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
